// extracted by mini-css-extract-plugin
export default {"dates":"styles_dates__mP7dp"};